import { IonFabButton } from "@ionic/react";
import { PersonAddAlt1Sharp } from "@mui/icons-material";




function YouTubeFab(props) {

    return(
        <div style={{ position: "fixed", right: "18px", bottom: "11px", zIndex: 1000000000 }}>
     <IonFabButton
      onClick={() => {
        props.setShowActionSheet(true);
      }}
      color={props.colorh}
      style={{ opacity: "50%" }}
     >
      <PersonAddAlt1Sharp />
     </IonFabButton> </div>
    );

}

export default YouTubeFab